export default __webpack_public_path__ + "static/media/image-not-found1.8dd13527.png";